var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.622 17.025h12.402c.806 0 1.46-.653 1.46-1.46V6.083c0-.806-.654-1.46-1.46-1.46H6.622a1.46 1.46 0 00-1.459 1.46v9.484c0 .806.653 1.459 1.46 1.459z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.516 12.648V2.434A1.46 1.46 0 012.975.975h13.131M15.742 10.824a1.824 1.824 0 110-3.648 1.824 1.824 0 010 3.648zM17.039 17.025L9.014 9l-3.84 3.84",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgImageType;